import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query GenerationToolSettings {
    generationToolSetting {
      useCase
      badgeNew
      badgeImproved
    }
  }
`;

export const queryGenerationToolSettings = () => {
  return executeGqlQuery({
    query: QUERY,
  }).then(({ data }) => getSingleProp(data));
};
